import { divideDataBetweenTables } from 'PDF/helpers/pdfMapping';
import { Fragment } from 'react/jsx-runtime';

import { IPointTableProps, PointTable } from './PointTable';
import { IHeaderItem } from './TableHeader';
import { IRowItem } from './TableRows';
import { SmallHeading } from '../SmallHeading';

const divideHeadersBetweenTables = (rows: IHeaderItem[]) => {
  const length = rows.length;
  const amount = length === 4 ? 2 : 3;
  const n = Math.ceil(length / amount);
  const arrays = new Array(n > 1 ? n : 1).fill('').reduce((result, current, index) => {
    const step = index === 0 ? 0 : index * amount;
    result.push(rows.slice(step, step > length ? length - 1 : step + amount));
    return result;
  }, []);

  return arrays;
};

export const PointTableWrapper = ({ headers, rows, heading }: IPointTableProps & { heading?: string }) => {
  if (
    headers.filter(({ name, image }) => name || image).length === 0 ||
    rows.filter(({ items }) => items.filter((item) => item.length > 0).length > 0).length === 0
  ) {
    return null;
  }

  const arraysOfHeaders: IHeaderItem[][] = headers.length > 3 ? divideHeadersBetweenTables(headers) : [headers];
  const arraysOfRows: IRowItem[][] = rows[0].items.length > 3 ? divideDataBetweenTables(rows, 'items') : [rows];

  return (
    <>
      {arraysOfHeaders.map((headers, index) => (
        <Fragment key={index}>
          {heading && !index && <SmallHeading heading={heading} minPresenceAhead={200} />}
          <PointTable headers={headers} rows={arraysOfRows[index]} noCapturedFirstColumn={index !== 0} />
        </Fragment>
      ))}
    </>
  );
};
